import { Login } from '@/features/login'

const LoginPage = () => <Login />

export default LoginPage
